import { Box } from '@mantine/core'
import React from 'react'
import ReactDOM from 'react-dom'

import { iconFlectoLogo } from '../assets/iconFlectoLogo'
import { Icon } from '../Icon/Icon'
import styles from './styles.module.css'

type LogoLoaderProps = {
  widthLayout?: boolean
  usePortal?: boolean
}

export function LogoLoader({
  widthLayout,
  usePortal = true,
}: LogoLoaderProps){
  const [mounted, setMounted] = React.useState(false)

  React.useEffect(() => {
    setMounted(true)
    return () => setMounted(false)
  }, [])

  const element = () => (
    <Box className={styles.loaderContainer} style={{ width: widthLayout ? '100%' : 'auto' }}>
      <Box className={styles.logoContainer}>
        <Icon icon={iconFlectoLogo} color='brand' size='sm' />
      </Box>
    </Box>
  )

  if (!usePortal) {
    return element()
  }

  return mounted
    ? ReactDOM.createPortal(
        element(),
        document.getElementById('loader-container') as HTMLElement
      )
    : null
}
